import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  initialize() {
    this.disableInputsDuringRequest()
  }

  disableInputsDuringRequest(){
    this.element.addEventListener('htmx:beforeSend', () => { this.disableAllInputs() })
    this.element.addEventListener('htmx:afterRequest', () => { this.enableAllInputs() })
  }

  disableAllInputs(){
    this.element.querySelectorAll("input").forEach((el) => { el.disabled = true })
  }

  enableAllInputs(){
    this.element.querySelectorAll("input").forEach((el) => { el.disabled = false })
  }

  onModalShow(_evt) {
    setTimeout(() => {
      this.element.querySelectorAll("label").forEach((el) => {
        el.style.opacity = "1"
      })
    }, 200)
  }

  onModalHide(_evt){
    this.element.querySelectorAll("label").forEach((el) => {
      el.classList.remove("-selected")
      el.style.opacity = "0"
    })
  }
}
